import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import Waypoint, { below as waypointBelow } from 'react-waypoint';

import IconBlock from 'components/IconBlockContainer/IconBlock/IconBlock';
import IconBlockContainer from 'components/IconBlockContainer/IconBlockContainer';
import localize from 'components/Localize/Localize';
import TransparentJPEG from 'components/TransparentJPEG/TransparentJPEG';

import imageConfig from './imageConfig';
import styles from './MattressThesis.css';
import translations from './translations';

const cx = classNames.bind(styles);

const renderAwards = (items) => {
  return items.map((item, i) => {
    return (
      <IconBlock
        icon={item.icon}
        key={i}
        title={item.title}
      />
    );
  });
};

const Awards = (props) => {
  if (!props.content) {
    return null;
  }

  return (
    <div className={styles[`icon-blocks`]}>
      <IconBlockContainer>
        {renderAwards(props.content)}
      </IconBlockContainer>
    </div>
  );
};

class MattressThesis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animateImage: false,
    };
    this.animateImage = this.animateImage.bind(this);
    this.resetImage = this.resetImage.bind(this);
  }

  animateImage() {
    this.setState({
      animateImage: true,
    });
  }

  resetImage({currentPosition}) {
    if (currentPosition === waypointBelow) {
      this.setState({
        animateImage: false,
      });
    }
  }

  render() {
    const imageClass = cx(`image`, {
      'image--end': this.state.animateImage,
    });
    const shadowClass = cx(`shadow`, {
      'shadow--end': this.state.animateImage,
    });

    return (
      <section className={styles[`container`]}>
        <div className={styles[`content`]}>
          <h2 className={styles[`heading`]}>{this.props.t.heading}</h2>
          <p className={styles[`body`]}>{this.props.t.body}</p>
        </div>
        <Awards content={this.props.t.awards} />
        <div className={styles[`image-wrapper`]}>
          <div className={styles[`image-container`]}>
            <TransparentJPEG
              description={this.props.t.imageDescription}
              id="thesis"
              imageClass={imageClass}
              imageConfig={imageConfig}
              ref={(el) => { this.mattressImage = el; }}
              shadowClass={shadowClass}
            />
            <Waypoint
              bottomOffset="-50"
              onEnter={this.animateImage}
              onLeave={this.resetImage}
            />
          </div>
        </div>
      </section>
    );
  }
}

MattressThesis.propTypes = {
  t: PropTypes.shape({
    awards: PropTypes.array,
    body: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    imageDescription: PropTypes.string.isRequired,
  }).isRequired,
};

export default localize(MattressThesis, translations);
